module.exports = __webpack_public_path__ + "static/img/1036_phase_function_Paper_PointsHejduk_Prediction.d79962b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1036_phase_function_Paper_PointsHejduk_Prediction.png
// module id = c5Jd
// module chunks = 0